// Phase 3 — Pricing Control tab shell.
// Rename of "Taxes & Fees" tab; mounts Phase 1 Taxes & Fees and Phase 3 Parts
// Matrix as internal sub-tabs. Tax logic and pricing logic remain fully
// separate — no shared state, hooks, or calculator paths.
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Receipt, LineChart } from 'lucide-react';
import { TaxesFeesTab } from '@/components/shop/taxes-fees/TaxesFeesTab';
import { useFeatureFlag, useExposureFlag } from '@/hooks/useFeatureFlags';
import { PricingMatrixSection } from '@/components/shop/pricing-matrix/PricingMatrixSection';
import type { TaxLookupAddress } from '@/lib/parts-financial/taxLookup';

interface Props {
  shopId: string;
  address: Partial<TaxLookupAddress>;
}

export function PricingControlTab({ shopId, address }: Props) {
  // Call both hooks unconditionally, then combine — a `&&` between two hook
  // calls short-circuits the second and violates rules-of-hooks.
  const pricingMatrixFlag = useFeatureFlag('partsPricingMatrix');
  const pricingMatrixExposure = useExposureFlag('ui_shopProfilePricingMatrix');
  const showPricingMatrix = pricingMatrixFlag && pricingMatrixExposure;

  return (
    <Tabs defaultValue="taxes-fees" className="space-y-6">
      <TabsList>
        <TabsTrigger value="taxes-fees" className="gap-2">
          <Receipt className="h-4 w-4" />
          Taxes &amp; Fees
        </TabsTrigger>
        {showPricingMatrix && (
          <TabsTrigger value="parts-matrix" className="gap-2">
            <LineChart className="h-4 w-4" />
            Parts Matrix (OptiGuard)
          </TabsTrigger>
        )}
      </TabsList>

      <TabsContent value="taxes-fees" className="space-y-6">
        <TaxesFeesTab shopId={shopId} address={address} />
      </TabsContent>

      {showPricingMatrix && (
        <TabsContent value="parts-matrix" className="space-y-6">
          <PricingMatrixSection shopId={shopId} />
        </TabsContent>
      )}
    </Tabs>
  );
}
